export const TAX_BEHAVIOR_LABELS = Object.freeze({
    inclusive: '税込み',
    exclusive: '税別',
    unspecified: '税別', // default is set to exclusive on Stripe billing settings
});
export const GRACE_HOURS_BEFORE_RENEWAL = 1;
